module.exports = __webpack_public_path__ + "static/img/jigou-yunnan-top.2398cc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-yunnan-top.png
// module id = j+46
// module chunks = 2